import isAlpha from "@/helpers/validation/isAlpha";

const getDefaultImageName = (name: string): string => {
  const firstLetter = name.trim()[0].toUpperCase();
  const alpha = isAlpha(firstLetter);

  if (!alpha) {
    return "imgZ";
  }

  return `img${firstLetter}`;
}

export default getDefaultImageName;